import type { AxiosInstance } from 'axios';
import { makeAuthHeaders } from './utils/make-auth-headers';

// Mirrors the Rust `SecurityLogEntry` / `SecurityLogResponse` in
// the backend's `audits::api`. Keep these in sync when the server shape
// changes.
export interface SecurityLogEntry {
  id: string;
  timestamp: string; // RFC3339
  operation_label: string;
  location: string;
  device: string;
  success: boolean;
}

export interface SecurityLogResponse {
  data: SecurityLogEntry[];
  total: number;
}

export interface SecurityLogQuery {
  page?: number;
  per_page?: number;
}

export interface RustySecurityLogProps {
  client: AxiosInstance;
}

export interface RustySecurityLogSpec {
  getSecurityLog(query: SecurityLogQuery, accessToken: string): Promise<SecurityLogResponse>;
}

export class RustySecurityLog implements RustySecurityLogSpec {
  private client: AxiosInstance;

  constructor({ client }: RustySecurityLogProps) {
    this.client = client;
  }

  async getSecurityLog(query: SecurityLogQuery, accessToken: string): Promise<SecurityLogResponse> {
    const params: Record<string, string | number> = {};
    if (query.page !== undefined) params.page = query.page;
    if (query.per_page !== undefined) params.per_page = query.per_page;
    const result = await this.client.get<SecurityLogResponse>('/a/audit', {
      params,
      headers: makeAuthHeaders(accessToken),
    });
    return result.data;
  }
}
